import styled from 'styled-components';

export const CardWrapper = styled.div`
    display: flex;
    max-width: 1080px;
    margin: 0 auto;
    justify-items: center;
    padding-top: 80px;
    padding-bottom: 80px;

    div {
        display: grid;
        background: #ffffff;
        justify-items: center;
        margin-left: 20px;
        padding: 20px;
        width: 300px;

        .icon {
            display: none;
        }

        img {
            width: 200px;
            height: 200px;
        }

        h1 {
            padding-top: 20px;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            color: var(--black);
        }

        p {
            padding: 20px;
            text-align: center;
            color: var(--gray);
        }
    }

    @media (max-width: 800px) {
            padding-top: 40px;
            flex-wrap: wrap;
            justify-content:center;

        div {
            margin-left: 0;
            width: 50%;
            &:nth-child(1n+2) {
                margin-top: 20px;
            }

        img {
            display: none;
        }

        .icon {
            display: block;
        }
    }
}
`;